import { isStreamArtifact } from '../../utils/hydrologyLegend';
import { CONNECTION_THRESHOLD_METERS, extractLineCoordinates, haversineDistance } from './streamUtils';
export const findAdjacentStreams = (selectedCoords, loadedArtifacts) => {
    var _a;
    const adjacent = new Map();
    if (selectedCoords.length === 0)
        return adjacent;
    const allEndpoints = [];
    for (const segment of selectedCoords) {
        if (segment.length >= 2) {
            allEndpoints.push(segment[0]);
            allEndpoints.push(segment[segment.length - 1]);
        }
    }
    if (allEndpoints.length === 0)
        return adjacent;
    for (const [artifactId, artifact] of loadedArtifacts.entries()) {
        if (artifact.type !== 'vector' || !isStreamArtifact(artifact))
            continue;
        const dataSource = artifact.cesiumObject;
        if (!((_a = dataSource === null || dataSource === void 0 ? void 0 : dataSource.entities) === null || _a === void 0 ? void 0 : _a.values))
            continue;
        for (const entity of dataSource.entities.values) {
            if (!entity.polyline)
                continue;
            const entityId = entity.id || '';
            const entityCoords = extractLineCoordinates(entity);
            if (entityCoords.length < 2)
                continue;
            const entityStart = entityCoords[0];
            const entityEnd = entityCoords[entityCoords.length - 1];
            const alreadySelected = selectedCoords.some((coords) => {
                if (coords.length < 2)
                    return false;
                const selStart = coords[0];
                const selEnd = coords[coords.length - 1];
                const matchForward = haversineDistance(entityStart, selStart) < 1 &&
                    haversineDistance(entityEnd, selEnd) < 1;
                const matchReverse = haversineDistance(entityStart, selEnd) < 1 &&
                    haversineDistance(entityEnd, selStart) < 1;
                return matchForward || matchReverse;
            });
            if (alreadySelected)
                continue;
            const connectsToAnyEndpoint = allEndpoints.some(endpoint => haversineDistance(endpoint, entityStart) < CONNECTION_THRESHOLD_METERS ||
                haversineDistance(endpoint, entityEnd) < CONNECTION_THRESHOLD_METERS);
            if (connectsToAnyEndpoint) {
                adjacent.set(entityId, { entity, artifactId, coords: entityCoords });
            }
        }
    }
    return adjacent;
};
